import { isAxiosError } from './objectUtils';

export type LogLevel = 'trace' | 'debug' | 'info' | 'warn' | 'error';

const normalizeArgs = (args: Array<any>) => {
  return args.map(arg => {
    if (isAxiosError(arg)) {
      return {
        ...arg.toJSON(),
        config: undefined,
      };
    }
    return arg;
  });
};

export class NbLogger {
  constructor(
    private name: string,
    private level: LogLevel = 'debug',
    private consoleLogEnabled = false,
  ) {}

  protected logEvent(_level: LogLevel, _origin: string, _message?: any, ..._optionalParams: any[]) {}

  trace(msg: string, ...args: Array<any>) {
    if (this.level === 'trace') {
      this.consoleLogEnabled && console.log(`[${this.name}] ${msg}`, ...args);
    }
    this.logEvent('trace', this.name, msg, ...normalizeArgs(args));
  }

  debug(msg: string, ...args: Array<any>) {
    if (['trace', 'debug'].includes(this.level)) {
      this.consoleLogEnabled && console.log(`[${this.name}] ${msg}`, ...args);
    }
    this.logEvent('debug', this.name, msg, ...normalizeArgs(args));
  }

  info(msg: string, ...args: Array<any>) {
    if (['trace', 'debug', 'info'].includes(this.level)) {
      this.consoleLogEnabled && console.log(`[${this.name}] ${msg}`, ...args);
    }
    this.logEvent('info', this.name, msg, ...normalizeArgs(args));
  }

  warn(msg: string, ...args: Array<any>) {
    if (['trace', 'debug', 'info', 'warn'].includes(this.level)) {
      this.consoleLogEnabled && console.warn(`[${this.name}] ${msg}`, ...args);
    }
    this.logEvent('warn', this.name, msg, ...normalizeArgs(args));
  }

  error(msg: string, ...args: Array<any>) {
    if (['trace', 'debug', 'info', 'warn', 'error'].includes(this.level)) {
      this.consoleLogEnabled && console.error(`[${this.name}] ${msg}`, ...args);
    }
    this.logEvent('error', this.name, msg, ...normalizeArgs(args));
  }
}
